import { Message } from "../interface/message.interface";

export function generateToken() {
  const rand = () => {
    return Math.random().toString(36).substr(2);
  };

  let longString = rand() + rand() + rand() + rand();
  return `thread_${longString}`;
}

export function pushMessage(messages: Message[], options: Message){

  const  {role, content, show, danger } = options;

  messages.push({ role, content, show: show, danger: danger });
}
